/** 표시용 placeholder — SSM/BizFile 등에서 State/City/Postcode 없음 → NA */
const ADDRESS_DISPLAY_PLACEHOLDER = /^(NA|N\/A|N\.A\.|NONE|null|-)$/i;

/**
 * 한 줄 주소 표시(join)용: trim 후 끝의 쉼표(반각·전각)와 그 뒤 공백을 반복 제거해
 * 조각 끝이 ","일 때 join(', ')로 생기는 ",," / ", ," 를 막는다.
 */
export function trimAddressJoinSegment(value: unknown): string {
  let s = String(value ?? '').trim();
  if (ADDRESS_DISPLAY_PLACEHOLDER.test(s)) return '';
  let prev = '';
  while (s !== prev) {
    prev = s;
    s = s.replace(/[,，]\s*$/u, '').trim();
  }
  return s;
}

/** 주소 한 줄에 붙는 Country 표시명 — 항상 대문자 (Malaysia → MALAYSIA) */
export function formatCountryForAddressDisplay(value: unknown): string {
  const s = trimAddressJoinSegment(value);
  return s ? s.toUpperCase() : '';
}

/** Country 콤보 CODE_NAME / title 표시 — 전부 대문자 */
export function formatCountryComboLabel(value: unknown): string {
  return String(value ?? '').trim().toUpperCase();
}

/** 주소 조각 join — 표시는 전부 대문자 */
export function joinAddressDisplayParts(parts: unknown[]): string {
  return parts
    .map((p) => trimAddressJoinSegment(p))
    .filter((p) => p.length > 0)
    .map((p) => p.toUpperCase())
    .join(', ');
}
